<template>
  <div class="bg-white h-screen flex items-center justify-center">
    <div class="text-center">
      <h2 class="text-4xl">{{ lang["please_wait"][language] }}</h2>
      <h4 class="text-3xl">{{ lang["payment_loading"][language] }}</h4>
      <ClipLoader color="black" class="mt-8" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const ClipLoader = require("vue-spinner/src/ClipLoader.vue").default;
import lang from "../lang";
import { GET } from "../utils";
import axios from 'axios';

export default {
  components: {
    ClipLoader,
  },
  data() {
    return {
      lang: lang,
    };
  },
  async mounted() {
    const sessionId = this.$route.query.sessionId;

    const orderDetails = await this.orderDetails(sessionId);

      try {
      let arr = [];
      arr.push("making emit request using postMessage method",orderDetails);
      arr.push("data",orderDetails);
      arr.push("session Id", this.$route.query.sessionId);
      let dummyData = {
        MenuHash:  this.$route.params.menuHash,
        Dump: JSON.stringify(arr),
      };
      
      axios.post(
        `${process.env.VUE_APP_API_BASE_PATH}/PostErrorDump`,
        dummyData
      );

    } catch (error) {
      // console.error()
    }

    // window.parent.postMessage(orderDetails, window.location.origin);
  },
  computed: {
    ...mapGetters(["menuHash","hasKiosk", "language"]),
  },
  methods: {
    // get the orderdata
    async orderDetails(sessionId) {
      const menuHash = this.$route.params.menuHash;
    if(this.hasKiosk){
      const resp = await GET.MENU_ITEMS({
        sessionId,
        menuHash,
      });

      return await resp.data.OrderAPI;
    }
    else{
      const resp = await GET.MENU_ITEMS({
        sessionId,
        menuHash,
      });

      return await resp.data.OrderAPI;
    }
    },
  },
};
</script>

<style></style>
